export default __webpack_public_path__ + "static/media/clover-element.9c077049.webp";